import { render, staticRenderFns } from "./InformationModule.vue?vue&type=template&id=89f10d7a&scoped=true&"
import script from "./InformationModule.vue?vue&type=script&lang=js&"
export * from "./InformationModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f10d7a",
  null
  
)

export default component.exports